import {
  type EditingNode,
  type NodeOrVoidNode,
  voidNode,
} from '@wandb/weave/core';

import {type PanelProps} from '../panel';
export const inputType = 'any' as const;

// Unlike other panels, this panel may receive a void node as input
export type PanelExpressionProps = Omit<
  PanelProps<typeof inputType, PanelExpressionConfig>,
  'input'
> & {
  input: NodeOrVoidNode<typeof inputType>;
  standalone?: boolean;
};

export interface PanelExpressionConfig {
  exp: EditingNode;
  panelId: string | undefined;
  panelConfig: any;
  exprAndPanelLocked?: boolean;
  // Set to true on newly added panels then immediately unset after focusing.
  // When using this, for fallback/default purposes, set it to false.
  // Callers that create an empty new Query Panel should set this to true.
  autoFocus?: boolean;

  // Temporary state to determine if any updates were performed with
  // weave backend enabled. This should be removed once weave python
  // gets to TS parity
  __weaveBackendRequired__?: boolean;
}

export const EMPTY_EXPRESSION_PANEL: PanelExpressionConfig = {
  exp: voidNode(),
  panelId: undefined,
  panelConfig: null,
  autoFocus: false,
} as const;
